import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/axios";
import "./work.css";

const defaultProject = {
  title: "",
  category: "web",
  url: "",
  image: "",
};

const WorkEdit = () => {
  const [projects, setProjects] = useState([]);
  const [form, setForm] = useState(defaultProject);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const fetchProjects = async () => {
    try {
      const res = await api.get("/works");
      setProjects(res.data);
    } catch (err) {
      console.error("Error fetching projects:", err);
      setError("Failed to load existing projects.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage("");
    setError("");
    try {
      await api.post("/works", form);
      setMessage("Project added successfully!");
      setForm(defaultProject);
      fetchProjects();
    } catch (err) {
      console.error("Error adding project:", err);
      setError(err.response?.data?.error || "Failed to add project.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this project?")) return;
    setError("");
    setMessage("");
    try {
      await api.delete(`/works/${id}`);
      setMessage("Project deleted successfully!");
      fetchProjects();
    } catch (err) {
      console.error("Error deleting project:", err);
      setError(err.response?.data?.error || "Failed to delete project.");
    }
  };

  return (
    <div className="work-edit-page">
      <div className="work-edit-header-nav">
        <button onClick={() => navigate("/")} className="back-btn">
          <i className="bx bx-left-arrow-alt"></i> Back to Home
        </button>
      </div>

      <div className="work-edit-grid">
        <div className="work-edit-container">
          <h2>Add New Project</h2>
          {message && <div className="status-message success">{message}</div>}
          {error && <div className="status-message error">{error}</div>}
          <form className="work-edit-form" onSubmit={handleSubmit}>
            <input
              name="title"
              placeholder="Project Title"
              value={form.title}
              onChange={handleChange}
              required
            />
            <input
              name="url"
              placeholder="Project Demo URL"
              value={form.url}
              onChange={handleChange}
              required
            />
            <input
              name="image"
              placeholder="Project Image URL (Optional)"
              value={form.image}
              onChange={handleChange}
            />
            <select name="category" value={form.category} onChange={handleChange}>
              <option value="web">Web</option>
              <option value="app">App</option>
              <option value="design">Design</option>
            </select>
            <button type="submit" disabled={submitting}>
              {submitting ? "Adding..." : "Add Project"}
            </button>
          </form>
        </div>

        <div className="work-list-container">
          <h2>Existing Projects</h2>
          {loading ? (
            <div className="loading-text">Loading projects...</div>
          ) : (
            <div className="work-edit-list">
              {projects.map((project) => (
                <div key={project._id || project.id} className="work-edit-item">
                  <div className="work-edit-item-info">
                    <h4>{project.title}</h4>
                    <span className="category-tag">{project.category}</span>
                  </div>
                  <button
                    onClick={() => handleDelete(project._id || project.id)}
                    className="delete-btn"
                    title="Delete Project"
                  >
                    <i className="bx bx-trash"></i>
                  </button>
                </div>
              ))}
              {projects.length === 0 && (
                <div className="no-projects-text">No projects available. Add one!</div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WorkEdit;
